export default "__VITE_ASSET__CthkDJNA__"